import axios, { AxiosResponse } from 'axios';
import { serverUrl } from '@platform/config';
import { IGetExternalEventsByFilterRequest } from '@core/Models/autogenerated/operation.models';

const endpoint = `${serverUrl}/api/ExternalEvent`;

type IExternalEventMandatory = {
    crm_tenant: string;
    crm_eventtype: string;
    // Add other known fields here
};

export interface IGetExternalEventsStreamReq {
    filter: any;
    fromDate?: Date;
    toDate?: Date;
}

// Define a type that allows any number of additional string properties
export type IExternalEvent = IExternalEventMandatory & {
    [key: string]: unknown;
};

export async function externalEventApiAdd(req: IExternalEvent): Promise<AxiosResponse<any, any>> {
    const resp = await axios.post(`${endpoint}/Add`, JSON.stringify(req));
    return resp;
}

export async function externalEventApiGetEventsByFilter(req: IGetExternalEventsByFilterRequest): Promise<AxiosResponse<any, any>> {
    const resp = await axios.post(`${endpoint}/GetExternalEventsByFilter`, JSON.stringify(req));
    return resp;
}

export async function* externalEventApiGetEventsByFilterStream(req: IGetExternalEventsStreamReq): AsyncGenerator<any, void, unknown> {
    const limit = 1000;
    let lastServerId = -1;

    while (true) {
        const response = await externalEventApiGetEventsByFilter({
            filter: req.filter,
            fromServerId: lastServerId + 1,
            fromDate: req.fromDate,
            toDate: req.toDate,
            limit,
        });

        const events = response.data;

        if (events.length === 0) {
            break;
        }

        for (const event of events) {
            lastServerId = Math.max(lastServerId, event.id);
            yield event;
        }
    }
}

function addDays(date: Date, days: number): Date {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}